import React, { ReactNode, isValidElement } from 'react';
import classNames from 'classnames';

export type ContentRowProps = React.PropsWithChildren<{
  /** classes that can be passed to the component */
  className?: string;
  /** sets a margin left by 20px */
  margined?: boolean;
  /** label of the ContentRow */
  label?: string | ReactNode;
  leftColumn?: ReactNode;
}>;

export const ContentRow = (props: ContentRowProps) => {
  const { leftColumn, label, margined, className, children } = props;

  return (
    <div className={classNames('flex flex-col', className)}>
      <div
        className={classNames('flex flex-row gap-xs', {
          'ml-xl': margined,
        })}
      >
        {leftColumn}

        <div className="flex w-full flex-col gap-xxxs">
          {isValidElement(label) ? (
            label
          ) : (
            <div className="line-clamp-2 break-all font-body text-label-small-bold text-strong">
              {label}
            </div>
          )}
          {children}
        </div>
      </div>
    </div>
  );
};

interface ContentProps {
  className?: string;
  children?: ReactNode;
  label?: string | ReactNode;
  badge?: ReactNode;
  link?: ReactNode;
}

export const Content = (props: ContentProps) => {
  const { children, className, label, badge, link } = props;

  return (
    <>
      {children ? (
        <> {children} </>
      ) : (
        <>
          <div
            className={classNames(
              'flex flex-wrap items-center gap-xxxs',
              className
            )}
          >
            <p className="whitespace-pre-line break-words font-body text-body text-regular">
              {label}
            </p>
            {badge}
          </div>
          {link}
        </>
      )}
    </>
  );
};

ContentRow.Content = Content;

export const CardContentRow = (
  props: React.PropsWithChildren<{
    label: string | ReactNode;
  }>
) => {
  const { label, children } = props;

  return (
    <div className="flex justify-between">
      <p className="text-body text-regular">{label}</p>
      <div className="text-body text-regular">{children}</div>
    </div>
  );
};

export default ContentRow;
